/* Native disclosures remain usable without JS. Hash links reveal their content. */
(() => {
  const root = document.querySelector('[data-ef-live-pdp-layout]');
  if (!root) return;
  // The source put the native receipt inside the hidden Review step. Keep the
  // same nodes/IDs before navigation so its real total is visible at every step.
  const receipts = root.querySelectorAll('#efCfgSidebar');
  const navigations = root.querySelectorAll('#efCfgNav');
  if (receipts.length === 1 && navigations.length === 1) {
    navigations[0].before(receipts[0]);
  }
  // Color names stay intact. Only the native zero-surcharge pricing line is
  // omitted, including after the engine rerenders a different finish category.
  const colors = root.querySelector('#efCfgSwatchGrid');
  if (colors) {
    const cleanIncludedLabels = () => {
      colors.querySelectorAll(':scope > .ef-cfg-swatch[data-surcharge="0"] > .ef-cfg-swatch__tooltip').forEach(tooltip => {
        const label = tooltip.lastChild;
        const lineBreak = label?.previousSibling;
        if (label?.nodeType === Node.TEXT_NODE && label.textContent.trim() === 'Included' && lineBreak?.nodeName === 'BR') {
          label.remove();
          lineBreak.remove();
        }
      });
    };
    cleanIncludedLabels();
    new MutationObserver(cleanIncludedLabels).observe(colors, { childList: true, subtree: true });
  }
  const reveal = hash => {
    if (!hash || hash === '#') return;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); }
    catch { return; }
    if (!target || !root.contains(target)) return;
    const detail = target.closest('#pdp-details details');
    if (!detail) return;
    detail.open = true;
    return detail;
  };
  root.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const detail = reveal(link.hash);
    if (!detail) return;
    // Native hash navigation moves focus away from summary. Own this small
    // in-page navigation, retaining its URL/back-button behavior explicitly.
    event.preventDefault();
    if (location.hash !== link.hash) history.pushState(history.state, '', link.hash);
    detail.querySelector('summary')?.focus({ preventScroll: true });
    detail.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  window.addEventListener('hashchange', () => reveal(location.hash));
  reveal(location.hash);
})();
